import React from 'react'
import clsx from 'clsx'
import { Button, Modal } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useFormStyles from '../common/FormFields/FormFieldsStyle'

const DeleteConfirmationModal = ({
  open,
  invitation,
  onClose,
  onDelete,
  text,
  children,
}) => {
  const handleDeleteClick = () => {
    onDelete(invitation)
  }
  const classes = useStyles()
  const formClasses = useFormStyles()

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.modal}>
        <h2>{text || '¿Está seguro que desea eliminar esta invitación?'}</h2>
        {children}
        <div className={classes.modalButtons}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDeleteClick}
            className={clsx(
              formClasses.primaryButton,
              formClasses.withRightMargin
            )}
            style={{ marginRight: '10px' }}
          >
            Confirmar
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            className={formClasses.secondaryButton}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles((theme) => ({
  modal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    position: 'fixed',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '30px',
  },
}))

export default DeleteConfirmationModal
